
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]",
      function () {
        return require("private-next-pages/news/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[slug]"])
      });
    }
  